import { useContext } from 'react';

import datetime from '@sayyesschool/common/libs/datetime';
import DetailsList from '@sayyesschool/frontend/components/details-list';
import PageSection from '@sayyesschool/frontend/components/page-section';
import DataContext from '@sayyesschool/frontend/contexts/data';
import { Image } from '@sayyesschool/frontend/ui-components';

export default function LearnerDetails({ learner }) {
    const data = useContext(DataContext);

    return (
        <PageSection
            title="Основные данные"
            compact
        >
            {learner.imageUrl &&
                <Image
                    src={learner.imageUrl}
                    alt=""
                />
            }

            <DetailsList items={[
                {
                    key: 'email',
                    icon: 'email',
                    content: learner.email || '[Не указана]',
                    header: 'Электронная почта'
                },
                ...learner.phones.concat(learner.phone)
                    .filter(Boolean)
                    .map((phone, index, phones) => ({
                        key: `phone-${index}`,
                        icon: 'phone',
                        content: phone,
                        header: phones.length > 1 ? `Телефон ${index + 1}` : 'Телефон'
                    })),
                {
                    key: 'dob',
                    icon: 'cake',
                    content: learner.dob ? datetime(learner.dob).format('DD.MM.YYYY') : '[Не указана]',
                    header: 'Дата рождения'
                },
                learner.address && {
                    key: 'address',
                    icon: 'location_city',
                    content: learner.address,
                    header: 'Адрес'
                },
                {
                    key: 'timezone',
                    icon: 'public',
                    content: learner.timezone ? data.timezones.get(learner.timezone) : '[Не указан]',
                    header: 'Часовой пояс'
                },
                learner.occupation && {
                    key: 'occupation',
                    icon: 'work',
                    content: learner.occupation,
                    header: 'Род деятельности'
                },
                learner.interests && {
                    key: 'interests',
                    icon: 'golf_course',
                    content: learner.interests,
                    header: 'Интересы'
                },
                learner.note && {
                    key: 'note',
                    icon: 'notes',
                    content: learner.note,
                    header: 'Примечание'
                }
            ]}
            />
        </PageSection>
    );
}